<cm-number-input
  [id]="id"
  [maskConfig]="maskConfig"
  [disabled]="disabled"
  placeholder="min"
  [ngModel]="value.from"
  (ngModelChange)="onValueChange({from: $event})"
  (blur)="onTouched($event)">
</cm-number-input>

<span class="minus"></span>

<cm-number-input
  [id]="id+'_to'"
  [maskConfig]="maskConfig"
  [disabled]="disabled"
  placeholder="max"
  [ngModel]="value.to"
  (ngModelChange)="onValueChange({to: $event})"
  (blur)="onTouched($event)">
